<template>
  <div class="message" :id="`message_${message.id}`" :class="getMessageClasses()">
    <div class="display_name_date">
      <div v-if="isShowFinePlayRadio()"
           class="btn-radio-fineplay"
           :class="{active: finePlaySelected}"
           @click="handleToggleFinePlay"
      ></div>

      <div class="default" v-if="!message.is_ng">
        <div>
          <span class="display_name">{{message.display_name}}</span>
          <span class="date">{{message.created_at | dateTimeFormat}}</span>
        </div>
        <span v-if="message.read_count" class="read_message">既読: {{message.read_count}}</span>
      </div>

      <div class="display_name_date_ngword" v-else>
        <span class="display_name">FINEよりお知らせ</span>
        <span class="date">{{message.created_at | dateTimeFormat}}</span>
      </div>
    </div>

    <div class="message-content">
      
      <!-- Message uploading -->
      <div v-if="message.uploading" class="content-uploading">
        <progress-bar
          :options="options"
          :value="percent"
        />
      </div>

      <!-- Message text -->
      <div v-else-if="!message.has_attachment || message.deleted_at" class="content" :class="getMessageContentClasses()">
        <span v-html="message.deleted_at ? 'メンバーによりメッセージが削除されました' : message.content"></span>
        <div v-if="!message.is_ng && !message.deleted_at">
          <span class="draft_button" @click="deleteMessage"></span>
          <span class="bookmark_button" @click="bookmarkMessage"></span>
          <span class="share_button" @click="favoriteMessage"></span>
        </div>
      </div>

      <!-- Message image -->
      <div v-else-if="checkTypeOfMessage(message) === 'image'" class="content-image">
        <img id="image-attachment" @click="handleClickImage(`${message.attachment_url}`)" :src="`${message.attachment_url}`">
      </div>

      <!-- Message file -->
      <div v-else class="content-file">
        <div class="file-name">{{message.attachment.file_name}}</div>
        <div class="file-size">{{message.attachment.size}}</div>
        <div class="file-type"><i class="el-icon-document"></i>File</div>
        <div class="DownLoadBtn"><a :href="`${apiBaseURL}/download/${message.attachment.id}`" target="_blank">Download</a></div>
      </div>
    </div>

    <div class="favorites_list" v-if="message.favorite_display_names !== ''">
      <span class="icon"></span>{{message.favorite_display_names}}
    </div>

    <div class="delete_button" :class="{'has_favorite': message.favorite_display_names}" v-show="displayBtnDelete">
      <div>
        <ul>
          <li @click="deleteMessage">削除</li>
          <!--<li @click="editMessage" v-if="!message.has_attachment && isOwner">編集する</li>-->
          <li @click="bookmarkMessage" v-if="message.has_attachment"><i class="el-icon-check" v-if="message.is_bookmark"></i> ブックマーク</li>
          <li @click="favoriteMessage" v-if="message.has_attachment"><i class="el-icon-check" v-if="message.is_favorite"></i> シェア</li>
        </ul>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import hammer from 'hammerjs'
  import _ from 'lodash'

  export default {
    data () {
      return {
        apiBaseURL: process.env.API_BASE_DOMAIN,
        pressTimer: 0,
        interval: false,
        displayBtnDelete: false,
        isOwner: false,
        options: {
          text: {
            color: '#1f67b6',
            shadowEnable: false,
            shadowColor: '#000000',
            fontSize: 13,
            fontFamily: 'Helvetica',
            dynamicPosition: true,
            hideText: false,
            textAlign: 'center'
          },
          progress: {
            color: '#1f67b6',
            backgroundColor: '#C0C0C0'
          },
          layout: {
            height: 50,
            width: 100,
            verticalTextAlign: 32,
            horizontalTextAlign: 2,
            zeroOffset: 20,
            strokeWidth: 10,
            progressPadding: 0,
            type: 'circle'
          }
        }
      }
    },
    watch: {
      'displayBtnDelete': function (val) {
        if (val) {
          const msgContainer = document.querySelector(`#message_${this.message.id} .message-content`)
          document.addEventListener('click', (event) => {
            if (!msgContainer.contains(event.target)) this.displayBtnDelete = false
          })
        }
      }
    },
    props: {
      finePlaySelected: {type: Boolean, default: false},
      message: {type: Object},
      ngWord: {type: Array},
      isViewMessage: {type: Boolean, default: false},
      percent: { type: Number, default: null }
    },
    computed: {
      ...mapGetters({enableFinePlay: 'navigator/enableFineplay'})
    },
    methods: {
      async bookmarkMessage () {
        this.displayBtnDelete = false
        this.$emit('bookmarkMessage', this.message)
      },
      async favoriteMessage () {
        this.displayBtnDelete = false
        this.$emit('favoriteMessage', this.message)
      },
      async deleteMessage () {
        this.displayBtnDelete = false
        this.$confirm('メッセージを削除します。よろしいですか？', '警告', {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'error',
          center: 'true'
        }).then(() => {
          this.$emit('deleteMessage', this.message)
        }).catch()
      },
      async editMessage () {
        this.displayBtnDelete = false
        this.$emit('editMessage', this.message)
      },
      async handleClickImage (url) {
        this.$emit('showImage', url)
      },
      async handleToggleFinePlay () {
        this.$emit('toggleFinePlayMessage', this.message)
      },
      checkTypeOfMessage (message) {
        return message.attachment.mime_type.split('/')[0]
      },
      handleCloseBtnDelete () {
        this.displayBtnDelete = false
      },
      getMessageClasses () {
        let classes = []
        if (this.message.employee_code === this.$auth.user().employee_code) classes = [...classes, 'right']
        if (this.message.is_bookmark) classes = [...classes, 'bookmarked']
        if (this.enableFinePlay) classes = [...classes, 'fineplay-active']
        if (this.message.favorite_display_names) classes = [...classes, 'favorited']
        if (this.message.deleted_at) classes = [...classes, 'deleted']
        return classes
      },
      getMessageContentClasses () {
        let classes = []
        if (this.displayBtnDelete) classes = [...classes, 'active-long-press']
        if (this.message.is_ng) classes = [...classes, 'ng-word']
        if (this.message.deleted_at) classes = [...classes, 'deleted']
        return classes
      },
      isShowFinePlayRadio () {
        return !(this.message.has_attachment || this.message.is_ng || this.message.deleted_at)
      }
    },
    async mounted () {
      const msgContainer = document.querySelector(`#message_${this.message.id} .message-content`)
      hammer(msgContainer).on('press', (e) => {
        const msgEl = document.getElementsByClassName('delete_button')
        document.querySelector('body').click()
        _.forEach(msgEl, n => { n.style.display = 'none' })
        if (!this.message.deleted_at) {
          this.displayBtnDelete = true
        }
      })
      this.isOwner = this.message.employee_code === this.$auth.user().employee_code
      document.oncontextmenu = document.body.oncontextmenu = function () {
        return false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/message.vue